import { render, staticRenderFns } from "./NumbersMobile.vue?vue&type=template&id=5d393456&scoped=true"
import script from "./NumbersMobile.vue?vue&type=script&lang=js"
export * from "./NumbersMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d393456",
  null
  
)

export default component.exports